import axios from 'axios';
export const LineAuthType = {
    signIn: 'sign_in',
};
export class LINEClient {
    constructor(config) {
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "channelId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loginState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "oauthCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "subWindowName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'line_oauth_window'
        });
        this.config = config;
        this.axios = axios.create();
        this.axios.interceptors.request.use((req) => {
            const header = {
                'Content-Type': 'application/x-www-form-urlencoded',
            };
            req.headers = Object.assign({}, req.headers, header);
            return req;
        });
        this.axios.interceptors.response.use((res) => {
            return res;
        }, (error) => {
            throw error;
        });
    }
    /*------ commands ------*/
    /**
     * LINEの認証画面に飛ばす。コールバック後に別関数でトークンが取得できる
     */
    openLINEAuth(type) {
        this.genLoginState();
        if (!this.redirectURI)
            return;
        if (type == 'sign_in') {
            window.location.href = this.redirectURI;
        }
    }
    /*------ utils ------*/
    setCode(code) {
        this.oauthCode = code;
    }
    get redirectURI() {
        return `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${this.config.lineChannelId}&redirect_uri=${this.config.lineCallBackUrl}&state=${this.loginState}&bot_prompt=normal&scope=openid%20email%20profile`;
    }
    /**
     * login前にgetしたstateとcallback後に返ってきたstateが同じか検証
     * @param state
     */
    validateState(state) {
        return this.loginState === state;
    }
    genLoginState() {
        const r = Math.random() * 10000000;
        this.loginState = String(r);
    }
}
